import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const initializeLocale = async (locale: string): Promise<void> => {
  await i18next
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      debug: process.env.APP_ENV === "development",

      ns: ["DeviceTestStrings"],
      defaultNS: "DeviceTestStrings",
      fallbackNS: "DeviceTestStrings",
      nsSeparator: false,

      lng: locale,
      fallbackLng: "en-US",
      partialBundledLanguages: false,

      saveMissing: true,
      saveMissingTo: "current",
      updateMissing: true,

      keySeparator: false,

      react: {
        wait: true,
      },

      backend: {
        loadPath: "assets/locales/{{lng}}/{{ns}}.json",
        addPath: "assets/locales/add/{{lng}}/{{ns}}",
      },
    });
};

export const changeLocale = async (locale: string): Promise<void> => {
  // change the language
  await i18next.changeLanguage(locale);
};

export const getLocale = (): string => {
  return i18next.language;
};
